import _regeneratorRuntime from 'babel-runtime/regenerator';
var _this = this;
function _asyncToGenerator(fn) {
  return function () {
    var gen = fn.apply(this, arguments);
    return new Promise(function (resolve, reject) {
      function step(key, arg) {
        try {
          var info = gen[key](arg);
          var value = info.value;
        } catch (error) {
          reject(error);
          return;
        }
        if (info.done) {
          resolve(value);
        } else {
          return Promise.resolve(value).then(function (value) {
            step("next", value);
          }, function (err) {
            step("throw", err);
          });
        }
      }
      return step("next");
    });
  };
}
import { callAPI } from './apiActions';
import tickersSubscriptionService from '../../services/subscriptions/tickersSubscriptionService';
export var RECEIVE_TICKERS = 'RECEIVE_TICKERS';
export var ADD_TICKERS = 'ADD_TICKERS';
export var REQUEST_TICKERS = 'REQUEST_TICKERS';
export var SET_TICKERS_INTERVAL = 'SET_TICKERS_INTERVAL';
export var fetchTickers = function fetchTickers() {
  return function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(dispatch, getState) {
      var selectedInstrumentId, interval, tickersConfig, tickers;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              selectedInstrumentId = getState().apexCore.instrument.selectedInstrumentId;
              interval = getState().tickers.interval;
              dispatch(requestTickers());
              tickersConfig = {
                OMSId: 1,
                InstrumentId: selectedInstrumentId,
                Interval: interval,
                IncludeLastCount: 500
              };
              _context.next = 6;
              return dispatch(callAPI('SubscribeTicker', tickersConfig));
            case 6:
              tickers = _context.sent;
              dispatch(receiveTickers(tickers));
            case 8:
            case 'end':
              return _context.stop();
          }
        }
      }, _callee, _this);
    }));
    return function (_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
};
export var subscribeToTickers = function subscribeToTickers() {
  return function (dispatch) {
    tickersSubscriptionService.subscribe(function (updates) {
      dispatch(addTickers(updates));
    });
  };
};
export var changeTickersInterval = function changeTickersInterval(interval) {
  return function (dispatch) {
    dispatch(setTickersInterval(interval));
    return dispatch(fetchTickers());
  };
};
export var unsubscribeTicker = function unsubscribeTicker(instrumentId) {
  return function () {
    return tickersSubscriptionService.stopOne(instrumentId);
  };
};
export var unsubscribeAllTickers = function unsubscribeAllTickers() {
  return function () {
    tickersSubscriptionService.stopAll();
  };
};
export var receiveTickers = function receiveTickers(payload) {
  return {
    type: RECEIVE_TICKERS,
    payload: payload
  };
};
export var addTickers = function addTickers(payload) {
  return {
    type: ADD_TICKERS,
    payload: payload
  };
};
export var requestTickers = function requestTickers() {
  return {
    type: REQUEST_TICKERS
  };
};
export var setTickersInterval = function setTickersInterval(payload) {
  return {
    type: SET_TICKERS_INTERVAL,
    payload: payload
  };
};